import { render, staticRenderFns } from "./DueDiligenceIndex.vue?vue&type=template&id=eb50b34a&"
import script from "./DueDiligenceIndex.vue?vue&type=script&lang=js&"
export * from "./DueDiligenceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb50b34a')) {
      api.createRecord('eb50b34a', component.options)
    } else {
      api.reload('eb50b34a', component.options)
    }
    module.hot.accept("./DueDiligenceIndex.vue?vue&type=template&id=eb50b34a&", function () {
      api.rerender('eb50b34a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/forms/due-diligence/DueDiligenceIndex.vue"
export default component.exports